import { Flex, Box, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import SvgContainer from "src/components/SvgContainer";
import { Caption, Subtitle } from "src/atoms/typography";
import { ReactComponent as ArrowIcon } from "./arrow-right.svg";

export default function ListButton({
  labelKey,
  label,
  content,
  icon,
  iconFill = "primary",
  onClick,
  imageSrc,
  additionalText,
  renderAdditionalIcon = true,
  additionalIcon,
  height = "48px",
  captionProps,
  disabled = false,
  ...rest
}) {
  const { t } = useTranslation();
  const labelString = labelKey ? t(labelKey) : label;

  if (renderAdditionalIcon && !additionalIcon) {
    additionalIcon = (
      <SvgContainer size="15px" icon={ArrowIcon} fill="lowEmphasis" />
    );
  }
  return (
    <Flex
      onClick={onClick}
      disabled={disabled}
      height={height}
      borderRadius="12px"
      border="1px solid"
      borderColor="outline"
      justifyContent="space-between"
      alignItems="center"
      transition="all 200ms ease"
      _hover={onClick ? { bg: "hover" } : undefined}
      _active={onClick ? { bg: "iconBackground" } : undefined}
      _disabled={{ opacity: 0.4, pointerEvents: "none" }}
      {...rest}
    >
      <Flex alignItems="center">
        {icon && (
          <SvgContainer
            size="20px"
            icon={icon}
            fill={iconFill}
            ml="16px"
            minWidth="20px"
          />
        )}
        {imageSrc && (
          <Image
            src={imageSrc}
            width="32px"
            height="32px"
            borderRadius="100%"
            ml="12px"
            my="12px"
          />
        )}
        {labelString && (
          <Subtitle ml="16px" color={"highEmphasis"}>
            {labelString}
          </Subtitle>
        )}
      </Flex>
      {content && <Box flex="1 1 auto">{content}</Box>}
      <Flex alignItems="center">
        {additionalText && (
          <Caption
            color={"mediumEmphasis"}
            ml="8px"
            mr={renderAdditionalIcon ? "0px" : "16px"}
            maxWidth="100px"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            {...captionProps}
          >
            {additionalText}
          </Caption>
        )}
        {additionalIcon && (
          <Box ml="8px" mr="16px">
            {additionalIcon}
          </Box>
        )}
      </Flex>
    </Flex>
  );
}
